// extracted by mini-css-extract-plugin
module.exports = {"greet":"styles_greet__L1Tl6","title":"styles_title__gyN04","description":"styles_description__34t6j"};